import { useTranslations } from '@vocab/react';
import { RadioGroup, RadioItem } from 'braid-design-system';
import type { FormEvent } from 'react';

import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';
import { useAppConfig } from 'src/modules/appConfig';

import {
  useGetShareableProfileStatus,
  useUpdateShareableProfileSettings,
} from '../data';

import translations from './.vocab';

export const SharedProfileVisibility = () => {
  const { t } = useTranslations(translations);
  const { zone, language } = useAppConfig();
  const { isShareableProfileActive, shareableProfileUrl } =
    useGetShareableProfileStatus();
  const { shareableProfileTogglePressed } = useAnalytics();

  const [updateShareableProfileSettings] = useUpdateShareableProfileSettings();

  const onChangeFn = ({
    currentTarget: { value },
  }: FormEvent<HTMLInputElement>) => {
    shareableProfileTogglePressed({
      active: value === 'on',
      isShareableProfileCreated: Boolean(shareableProfileUrl),
    });

    updateShareableProfileSettings({
      active: value === 'on',
      zone,
      languageCode: language,
    });
  };

  return (
    <RadioGroup
      id="sharedProfileOptions"
      label={t('Set visibility')}
      onChange={onChangeFn}
      value={isShareableProfileActive ? 'on' : 'off'}
      data={{ automation: 'shareable-profile-options' }}
    >
      <RadioItem
        data={{ automation: 'shared-profile-on-option' }}
        label={t('Shared Profile on')}
        description={t(
          'Your Shared Profile can be viewed, and reshared by others via your shared link.',
        )}
        value="on"
      />
      <RadioItem
        data={{ automation: 'shared-profile-off-option' }}
        label={t('Shared Profile off')}
        description={t(
          'Your Shared Profile cannot be seen via your shared link.',
        )}
        value="off"
      />
    </RadioGroup>
  );
};
